import { render, staticRenderFns } from "./ZopimSettingsTab.vue?vue&type=template&id=6c8d09e6&scoped=true&"
import script from "./ZopimSettingsTab.vue?vue&type=script&lang=js&"
export * from "./ZopimSettingsTab.vue?vue&type=script&lang=js&"
import style0 from "./ZopimSettingsTab.vue?vue&type=style&index=0&id=6c8d09e6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c8d09e6",
  null
  
)

export default component.exports